<template>
    <div class="empty-numbers">
        <template v-if="error">
            <i class="material-icons error-icon">error_outline</i>
            <div class="error-message">{{ error.message || "Bir hata oluştu" }}</div>
        </template>
        <template v-else-if="!hasValidSettings">
            <i class="material-icons settings-icon">settings</i>
            <div class="message">Widget ayarları yapılandırılmamış</div>
        </template>
        <template v-else>
            <loading-wave text="Veriler yükleniyor..." />
        </template>
        <a-button v-if="!error" type="primary" @click="$emit('edit')">
            <i class="material-icons">settings</i>
            Ayarları Yapılandır
        </a-button>
    </div>
</template>

<script>
import Vue from "vue";
import LoadingWave from "../../../../../../../components/common/LoadingWave.vue";

export default Vue.extend({
    name: "EmptyNumbers",
    components: {
        LoadingWave
    },
    props: {
        error: {
            type: Object,
            default: null,
        },
        hasValidSettings: {
            type: Boolean,
            required: true,
        },
    },
});
</script>

<style scoped lang="scss">
.empty-numbers {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    text-align: center;
    color: rgba(0, 0, 0, 0.45);

    .material-icons {
        font-size: 48px;
        margin-bottom: 16px;

        &.error-icon {
            color: #ff4d4f;
        }

        &.settings-icon {
            color: #1890ff;
        }
    }

    .message,
    .error-message {
        margin-bottom: 16px;
        font-size: 14px;
    }

    .error-message {
        color: #ff4d4f;
    }
}
</style> 